import React from 'react';

import { Stack, StackProps } from '@mui/material';

type Props = StackProps;

export const Row = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
	return (
		<Stack
			direction="row"
			{...props}
			ref={ref}
			sx={[
				{
					alignItems: 'center',
				},
				...(Array.isArray(props.sx) ? props.sx : [props.sx]),
			]}
		>
			{props.children}
		</Stack>
	);
});

Row.displayName = 'Row';
